import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
const FormData = ({
    show,
    handleClose,
    formAttribute,
    handleChange,
    handleSubmit,
    isLoading,
    validate
}) => {
    const { title, data } = formAttribute;    
    const vcimage = data.vcimage === '' || data.vcimage === null ? '' : `data:image/jpeg/jpg/png;base64,${data.vcimage}`
    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header className="bg-card-gradient light border-bottom-0">
                <Modal.Title className="text-white">{title}</Modal.Title>
                <FalconCloseButton onClick={handleClose} variant="white"/>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate validated={validate} onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formGroupNama">
                        <Form.Label>Nama</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcname}
                            onChange={(event) => handleChange(event)}
                            name="vcname"
                            placeholder="Nama" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nama tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNamaPanggilan">
                        <Form.Label>Nama Panggilan</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcnickname}
                            onChange={(event) => handleChange(event)}
                            name="vcnickname"
                            placeholder="Nama Panggilan" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nama Panggilan tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNama">
                        <Form.Label>Nomor Seri Becak</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcnip}
                            onChange={(event) => handleChange(event)}
                            name="vcnip"
                            placeholder="Nomor Seri Becak" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nomor Seri Becak tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupAlamat">
                        <Form.Label>Alamat</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={data?.vcaddress} 
                            onChange={(event) => handleChange(event)} 
                            name="vcaddress" 
                            placeholder="Alamat"
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Alamat tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formGroupNomorHp">
                        <Form.Label>Nomor Telepon / HP</Form.Label>
                        <Form.Control
                            type="text"
                            value={data?.vcphone}
                            onChange={(event) => handleChange(event)}
                            name="vcphone"
                            placeholder="Nomor Telepon / HP" 
                            required
                        />
                        <Form.Control.Feedback type="invalid">
                            Nomor Telepon / HP tidak boleh kosong.
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formImage">
                        <Form.Label>Gambar</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={(event) => handleChange(event)}
                            name="vcimage"
                            placeholder="Gambar"
                        />
                        <img src={vcimage} alt="default" width="20%" className={vcimage === '' || vcimage === null ? 'd-none' : ''}/>
                    </Form.Group>

                    <Form.Group className="mb-3 d-none" controlId="formGroupUseAccount">
                        <Form.Check 
                            type="checkbox"
                            label="Menggunakan Akun?"
                            name="intfungsional"
                            checked={data?.intfungsional === 1 ? true : false}
                            onChange={(event) => handleChange(event)}
                        />
                    </Form.Group>
                    {
                        data?.intfungsional === 1 && (<>
                            <Form.Group className="mb-3" controlId="formGroupUserName">
                                <Form.Label>Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={data?.vcusername}
                                    onChange={(event) => handleChange(event)}
                                    name="vcusername"
                                    placeholder="Username"
                                />
                                <Form.Control.Feedback type="invalid">
                                    Username tidak boleh kosong.
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formGroupPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={data?.vcpassword}
                                    onChange={(event) => handleChange(event)}
                                    name="vcpassword"
                                    placeholder="Password"
                                />
                                <Form.Control.Feedback type="invalid">
                                    Password tidak boleh kosong.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </>)
                    }

                    <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
                        <FontAwesomeIcon icon={faTimes} className="me-2" /> Tutup
                    </Button>
                    <Button disabled={isLoading} type="submit" className="float-end">
                        {isLoading ? (<>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Loading...
                        </>
                        ) : (<>
                            <FontAwesomeIcon icon={faSave} className="me-2" />
                            Simpan
                        </>) }
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

FormData.propTypes = {}

export default FormData;